import { Injectable } from "@angular/core";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { Subject } from "rxjs";
import { TranslateDto } from "src/app/core/models/translate/translate.dto";
import { TranslateHelper } from "../helpers/translate.helper";
import { SendInfoComponentService } from "src/app/core/services/local/send-info.component.service";

@Injectable({
    providedIn: 'root'
})
export class TablePaginatorIntl implements MatPaginatorIntl {
    listTranslate: TranslateDto;

    constructor(sendInfo: SendInfoComponentService){
        this.listTranslate = TranslateHelper.getTranslation("table");
        sendInfo.sendObjectAction.subscribe(res => {
            if (res.isExecuted && res.key === "traduction") {
                //Colocar la traduccion del control table
                this.listTranslate = TranslateHelper.getTranslation("table");
                this.setLabels();                
            }
        });
        this.setLabels();
    }
    //Translate Paginator
    changes: Subject<void> = new Subject<void>();
    itemsPerPageLabel: string = "Registros por página";
    nextPageLabel: string = "Siguiente";
    previousPageLabel: string = "Anterior";
    firstPageLabel: string = "Inicio";
    lastPageLabel: string = "Último";
    //range
    range1: string = "";
    range2: string = "";
    

    getRangeLabel = (page: number, pageSize: number, length: number) => {
        if (this.range1) {
            if (length === 0) {
                return $localize`` + this.range1;
            }            
            let pageInit: number = page + 1;            
            let rowsFin: number = pageInit * pageSize;
            let rowsIni: number = (rowsFin - pageSize) + 1;

            let range = "";
            if(rowsFin > length)
                range = `${rowsIni}` + ' - ' + `${length}`;
            else
                range = `${rowsIni}` + ' - ' + `${rowsFin}`;            
            
            let labelRange = this.range2.replace("X", `${range}`).replace("Y", `${length}`);
            labelRange = this.getLabelRange(labelRange);
            return $localize`` + labelRange;
        }
        return "";
    };

    setLabels(){
        this.itemsPerPageLabel = this.listTranslate.lbl.get("lbl_items_per_page");
        this.nextPageLabel = this.listTranslate.lbl.get("lbl_next_page");
        this.previousPageLabel = this.listTranslate.lbl.get("lbl_previous_page");
        this.firstPageLabel = this.listTranslate.lbl.get("lbl_first_page");
        this.lastPageLabel = this.listTranslate.lbl.get("lbl_last_page");
        this.range1 = this.listTranslate.lbl.get("lbl_range_page_1");
        this.range2 = this.listTranslate.lbl.get("lbl_range_page_2");
        this.changes.next();
    }

    getLabelRange(range: string){
        if(this.itemsPerPageLabel.includes("Registros")){
            range = range.replace("Página", "Registros");
        } else if(this.itemsPerPageLabel.includes("Rows")){
            range = range.replace("Page", "Rows");
        } else {
            range = range.replace("Página", "Linhas");
        }
        return range;
    }
}